module.exports = __webpack_public_path__ + "img/faq_w.608d920a.svg";